import * as React from 'react';

const ArrowDown = ({ className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      <path d="M938.667 307.846l-426.667 481.487-426.667-481.487 71.103-73.18 355.564 408.41 355.563-408.41 71.104 73.18z"></path>
    </svg>
  );
};

export default ArrowDown;
